import store from '@/store'
import socket from './socket'

export default function initSocketListeners() {
  
  // CHAT MESSAGE
  socket.on("chatMessage", (payload) => {
    

    store.dispatch("chatSocketMessage", {
      message: {
        _id: payload._id || Math.random().toString(36).substring(2),
        type: "user",
        user: {
          _id: payload.userId,
          username: payload.username,
          avatar: payload.avatar,
          rank: payload.rank || "user",
          level: payload.level || 1,
          rakeback: payload.rakeback || null
        },
        message: payload.message,
        room: payload.room,
        createdAt: payload.createdAt
      }
    });
  });

  console.log("SOCKET LISTENERS INITIALIZED");
}
